<template>
<div>
  <CountryView />
     <section class="term">
        <div class="termson">
     <h2 class="question">Privacy Notice</h2>
     <p class="termp">
        <b class="">1. INTRODUCTION</b> <br><br>
       1.1  SwyChr Technology Africa Limited owns and operates the website: www.swychr.com <br><br>

        1.2   This Privacy Policy is part of the Terms of Use relating to the use of our mobile app 
        and website, and by using the mobile app and/or Website you expressly consent to our collection, 
        use and disclosure of your information in accordance with the terms of this Policy. We may amend
         this Policy at any time without notice, and such amendments become effective from the date upon 
         which we make them available on the Website. If you do not agree to the Policy (including any
          amendments), then you should immediately cease using our mobile app and/or Website.<br><br>

        1.3Throughout this Policy, the terms “we”, “our”, “us” means SwyChr Technology Africa
         Limited, our employees, agents, affiliates or assigned parties. <br><br>
        

      1.4  This Privacy Policy is effective between you and us as of the date you accept this Policy, 
      and you do so by default through the use of our mobile app and/or Website.<br><br>
      
      1.5  If any term of this Policy is or may become for any reason invalid or unenforceable at law,
       the validity and enforceability of the remainder will not be affected.<br><br>

      1.6  Data Controller refers to a person, individually or as a group or legal entity, who, determines 
      the purposes for which and the manner in which any personal data are to be processed.<br><br>
      
      1.7  SwyChr Technology Africa Limited is the Data Controller in respect of personal data processed
       by this our website and mobile application.<br><br>

       <b class="">2. YOUR INFORMATION</b> <br><br>

       2.1 The type of information we collect would either be general in nature or personal to you.<br><br>

       General Information: We receive more general information from you as a result of your visits to, and
        use of our mobile app and website. This general information does not identify you personally, and
         can include information such as your IP address, the date and time you access the app or website,
         length of time you spend on the app or website, your browsing history, the Internet address of the 
         website from which you linked directly to our mobile app or website, and other such ‘General Information’.<br><br>

         Personal Information: When you register on the app or website as a user, update your information, purchase
         any services, participate in promotions or campaigns, using Personal Information or a social media account,
          send emails to us, send support requests, contact agents via their profile or phone numbers made available
          on our mobile app or website, provide feedback, or when you report a problem with our mobile app or website,
           you provide us with information that we store and process. Such information may include your name, address, 
           phone number, email address, purchase and transaction history, billing information (including credit card 
           information), interests, and other such ‘Personal Information’.<br><br>

         Payment Data: Payment Data is the information that you provide when you make online purchases. This may include
         your credit card information, mobile money account and any other relevant details you use in carrying out a payment
          transaction. You hereby acknowledge and agree that the Payment Data, to the extent consisting of details related 
          to the manner and mode of payment of fees for the use of the mobile app or website and Services (such as details
           of your bank account, credit card, debit card, etc.), submitted by you while making payment of fees: <br><br>
           
           
      -Goes through a safe and secure transaction process provided by SwyChr Technology Africa Limited’s payment 
      gateway partners;<br>
      - Goes through the Visa, MasterCard or any other provider’s pages, as the case may be, based on your payment
       method(s) in order to prevent any misuse of your payment details; and<br>

      - That such payment details are not shared with the app or website, SwyChr Technology Africa Limited, it affiliates
       and third parties or any other users of the app and/or website and Services.<br><br>
       
       
       Information we receive from other Sources: We may receive information about you if you use any of the websites or
       mobile app operated by us, or from any other services that we provide. We may also obtain your information from close
        third parties, including but not limited to, business partners, service providers, advertising networks, analytics 
        providers, and search information providers. Such information may be combined with other information you provide 
        to us, as described above.<br><br>
  
      <b class="">3. INFORMATION COLLECTION AND USAGE</b> <br><br>

      3.1 A great part of this mobile app or website can be used without much information from you. However, certain
       services and third-party technology may involve collection and usage of information from you, including but not
        limited to, Google Analytics (a description of their specific data collection and processing practices can be 
        found via the following link: (https://www.google.com/policies/privacy/partners/).<br><br>

       -To provide any services that you request from us;<br>
       -To provide a better service, and in particular to: keep internal records, as well as, improve
       our products, services and the mobile app and/or website;<br>
       -To communicate with you if you have transacted or participated in anything on the mobile app and Website;<br>
       -To contact you for market research purposes;<br><br>

       -To provide you with information about new opportunities, promotions, special offers and other information
        that we may feel is relevant to you. If you contact us via our mobile app or website, or via email to the
        contacts set out on the mobile app or website, we may keep a record of that correspondence.<br>
       
       -To provide you, or permit other selected third parties to provide you, with information about 
       goods or services that you may be interested in; <br>

       -To customize or enhance your experience on our mobile app and/or website and services, including via the
        display of adverts and direct communications you receive from us, which may be based on your activity<br>
        on our mobile app or website. <br>

      -To measure or understand the effectiveness of advertising we serve to you and others, and to deliver relevant
       advertising to you, which may be based on your activity on our mobile app or website; and<br>
       
      -To make suggestions and recommendations to you and other users of our mobile app or website about services
       that may interest you or them, which may be based on your activity on our mobile app or website.<br><br>

       3.3 General Information is used by us to help make the app and website more useful to customers
        (including to help us assess content of interest to visitors), and for other purposes such as
        determining the app and Website’s technical design specifications and identifying system performance
         or problem areas, for tracking activity on the app and website, preparing reports, assessing trends,
          and otherwise monitoring the way in which the app and website is being used none of which would be 
          in a way that personally identifies any users.<br><br>

     <b class="">4. PERSONAL INFORMATION DISCLOSURE</b> <br><br>

     4.1  We may share your Personal Information in connection with the purposes above.<br><br>

     4.2 You consent to us sharing your Personal Information with third parties in the following circumstances:<br><br>
     
     -To selected agents, relevant authorities or service providers that we use, where requested or is implied as part
      of your use of the mobile app or website. For example, when you enquire about a remittance service of interest to
       you, we will pass your Personal Information to the partners handling that service in question. Upon receipt of 
       your Personal Information, the relevant third party is the Data Controller and their use of your information 
       will be governed by their own terms of use and privacy policy; and<br>

     -Business partners, suppliers and sub-contractors for the performance of any contract we
     enter into with them or you.<br>

     -To our third-party service providers. We partner with and are supported by service providers
      around the world. Personal information will be made available to these parties only when necessary
      , to fulfil the services they provide to us, such as software, system, and platform support; direct
       marketing services; cloud hosting services; advertising; data analytics; and order fulfilment and 
       delivery. Our third-party service providers are not permitted to share or use personal information 
       we make available to them for any other purpose than to provide services to us.<br>
 
     
     4.3 We may also share your Personal Information with third parties:<br><br>

      -Should this be required in order to obtain professional advice;<br>
      -If we are under a duty to disclose or share your Personal Information in order to comply with any 
      legal obligation, or in order to enforce or apply our terms of use and other agreements; or<br>

      -To protect the rights, intellectual property, or safety of SwyChr Technology Africa Limited, our
       customers, or others. This includes exchanging information with other companies and organizations 
       for the purposes of fraud protection.<br><br>

      <b class="">5. SECURITY</b><br><br> 

      5.1 Keeping your Personal Information secure and preventing unauthorized access is of utmost priority 
      to us, and we take all steps reasonably necessary to protect your Personal Information against any 
      unauthorized access, use, alteration, disclosure or destruction. Whilst we have put in place physical, 
      electronic and managerial procedures to secure and safeguard your Personal Information, we will not be
       held responsible for any unauthorized access by third parties and we cannot guarantee that the Personal
        Information provided by you or that is transmitted via this app and Website or by e-mail is totally 
        secure and safe.<br><br> 

        <b class="">6. STORAGE OF YOUR PERSONAL INFORMATION</b><br><br> 

        6.1 The information that we collect from you may be transferred to,
        and stored in a country outside the country in which SwyChr Technology
         Africa is located, for who’s website you have accessed in order for the 
         information to be collected. It may also be processed by staff operating
          outside such country, who work for us or for one of our suppliers. By 
          submitting your information, you agree to this transfer, storage, and/or 
          processing. We will take all steps reasonably necessary to ensure that your
           data is treated in accordance with this Policy.<br><br> 

        6.2 Where we have given you, or where you have created a password which is part 
        of our services or allows you to access parts of our mobile app and website, you 
        are responsible for keeping this password confidential. We ask you not to share 
        your password with anyone.<br><br>
             
          6.3  Unfortunately, the transmission of information via the internet is not
           completely secure. We will do our best to protect your personal information,
            we cannot guarantee the security of your information transmitted to our mobile 
            app or website. Any transmission of information made, is done so at your own risk. 
            Once we have received your information, we will use strict procedures and security
             features to try to prevent unauthorized access.<br><br>

          <b class="">7. ACCESS RIGHTS AND CORRECTION OF PERSONAL INFORMATION</b><br><br>   

          7.1  We respect your right to access and control your information, and we will respond 
          to requests for information and, where applicable, will correct, amend, or delete your
           personal information. Any such request can be made to info@swychr.com.<br><br>  

          7.2 Access to personal information: If you request access to your personal information,
           we will gladly comply, subject to any relevant legal requirements and exemptions,
            including identity verification procedures. Before providing data to you, we will ask 
            for proof of identity and sufficient information about your interaction with us so that
             we can locate any relevant data. We may also charge you a fee for providing you with a 
             copy of your data (except where this is not permissible under local law).<br><br>
             
           7.3 Correction and deletion: You have the right to correct or amend your personal information
            if it is inaccurate or requires updating. You may also have the right to request deletion
             of your personal information; however, if this is possible due to legal requirements and
             other obligations and factors. <br><br>

           7.4 Marketing preferences: To opt out of email marketing, you can use the unsubscribe link 
           found in the email communication you receive from us or by sending an email to info@swychr.com.<br><br>

           For other marketing preferences, you can contact us via any relevant link in the marketing
            communication, or by sending an email to info@swychr.com. Information related to controlling
             cookies, and information related to Interest-Based and Mobile Advertising can be found in 
             this Policy herein.<br><br>  
        
          <b class="">8. USE OF COOKIES</b><br><br>   
          
        8.1Like many mobile applications and websites, our platforms may use cookies (which may also
         be placed and read by third party providers, including but not limited to Google Analytics 
         and Double Click for Publisher. Further information regarding Google partner sites can be 
         found at the following link: https://www.google.com/policies/privacy/partners/), which are
          files that collect data and store information on your hard drive. Cookies are used for 
          purposes that include but are not limited to allowing the user of such information or 
          the platform to identify account holders, track new users, record session information, 
          and generally to optimize your experience. For online advertising campaigns, cookies are
           automatically deleted after a period of time that can be provided upon request.<br><br>
            
      8.2  Most browsers accept cookies automatically but if you choose you can disable the cookies 
      from your browser, you may find that certain functions and features will not work as intended
       on the Services.<br><br>

      8.3 We understand that you may want to know more about cookies. Here are some useful resources
       that provide detailed information about types of cookies, how they are used, and how you can
        manage your cookie preferences: http://www.aboutcookies.org/ or
         http://www.allaboutcookies.org/.<br><br>
         
        <b class="">9. USE OF THIRD-PARTY ANALYTICS AND TRACKING PIXELS</b><br><br>  
        
        9.1 This website and mobile application uses third party analytics (“Third Party Analytics”). 
        Third Party Analytics use cookies and/or text files to analyze app and website traffic.
         Information generated by cookies with your details (including your IP address) is transferred
          to servers operated by Third Party Analytics. Third Party Analytics process this information
           to evaluate your use of our app or website, compile reports about this Website’s activity
            on our behalf, and deliver other related services regarding website and Internet use.
             Third Party Analytics may also share this information with third parties insofar as 
             this is necessary or if these third parties process the information on behalf of them.<br><br>  

        9.2 Third party tracking pixels are used on our Website and mobile application. This means that third
         parties may use cookies, web beacons, and similar technologies to collect or receive information 
         from our mobile app and website and elsewhere on the internet and use that information to provide
          measurement services and target adverts. If you wish to opt out of the use of these tracking 
          pixels, please adjust your browser settings.<br><br> 

           <b class="">10. WEB SERVER & APPLICATION LOGS</b><br><br>

        10.1 Our servers automatically collect certain information
         to help us administer and protect the Services, analyze usage, 
         and improve users’ experience. The information collected includes,
         amongst others:<br><br>

         -IP address and browser type;<br>
         -Device information including Unique Device Identifier (UDID), MAC
          address, Identifier for Advertisers (IFA), and similar identifiers we or others may assign;<br>
         -Device operating system and other technical facts;<br>
         -Pages visited and content viewed, stored, and purchased;<br>
         -Information or text entered;<br>
         -Links and buttons clicked;<br>
         -URLs visited before and after you use our Services.<br><br>
         
          <b class="">11. THIRD PARTY ADVERTISERS</b><br><br>

      11.1 We may allow third party advertising networks to serve advertisements on our behalf.<br><br>

      11.2 Third party advertisers may place cookies on the browsers of visitors to its website(s) 
      and may send its own cookies to the visitors’ cookie file. The cookies will allow these 
      third-party advertisers to apply their personalized retargeting technology and to serve 
      personalized banners; third party advertisers may collect and use this data in accordance
       with all applicable laws and regulations (including but not limited to laws governing privacy,
        and data protection).<br><br>

       <b class="">12. INTEREST-BASED ADVERTISING (IBA)</b><br><br>

       12.1 Interest-based advertising (IBA) allows us to deliver targeted advertising to users of our
        Services. IBA works by showing you advertisements that are based on the type of content you
         access or read. For example, as you browse our Services, one of the cookies placed on your
          device will be an advertising cookie so we can better understand what sort of pages or 
          content you are interested in. The information collected about your device enables us to
           group you with other devices that have shown similar interests. We can then display
            advertising to categories of users that is based on common interests.<br><br>

        12.2 If you want to opt out of receiving interest-based advertising, it does not mean 
        that you will no longer receive advertising when you are using our Services. It just means 
        that we will not use information collected about you for IBA and that any advertising you
         see will not be customized or relevant to you. You can exercise your online advertising
          choices at http://optout.aboutads.info or by clicking the Ad Choices icon in an ad and
           following the instructions. You may also opt out of receiving interest-based ads from
            many sites through the Network Advertising Initiative’s (NAI) Opt Out Tool 
            (http://www.networkadvertising.org/choices) and in the EU 
            at http://www.youronlinechoices.com/. Remember, if you delete cookies, use a different
             device, or change web browsers, you may need to opt out again. <br><br>
             
         12.3 Mobile devices have an identifier that gives companies the ability to serve targeted 
         ads to a specific mobile device. In many cases, you can turn off mobile device ad tracking
          or you can reset the advertising identifier at any time within your mobile device privacy
          settings. Another tool you can use to control advertising on your mobile device is the Ad
           Choices App: http://youradchoices.com/appchoices. You may also choose to turn off location
            tracking on your mobile device. If you turn off ad tracking or location tracking, we will 
            no longer use information collected from your device’s advertising identifier for the 
            purposes of advertising. You may still see the same number of ads but they may be less 
            relevant because they will not be based on your interests.  <br><br>

           <b class="">13. LINKS AND CONNECTIONS TO AND USE OF OTHER THIRD-PARTY SERVICES</b><br><br>  
           
           13.1 Our Services may contain links to and may be used by you in conjunction with third-party 
           apps, services, tools, and websites that are not affiliated with, controlled, or managed by us.
            Examples include but are not limited to Facebook, LinkedIn, Twitter and, third-party apps like
            voice software and readers. The privacy practices of these third parties will be governed by
             the parties’ own Privacy Statements. We are not responsible for the security or privacy of 
             any information collected by these third parties. You should review the privacy statements 
             or policies applicable to these third-party services.<br><br> 

          13.2 Information that you provide to third-party companies is not covered by this Policy.<br><br> 
          
          <b class="">14. PRIVACY OF MINORS</b><br><br>  

          14.1 Our Services are not aimed at individuals under the age of eighteen (18) years old
           (“minors”). If, however, we collect and use information about any minor, we will comply
           with the applicable laws.<br><br>  

          14.2 We hereby prohibit all Minors from the use of any website, mobile app or service 
          governed by this Policy, which includes those websites and services operated or provided 
          by Jump The Q Limited and SwyChr.<br><br>  

            <b class="">15. BUSINESS TRANSFER</b><br><br> 

            15.1 Information obtained pursuant to this Policy, including Personal Information, may
            be transferred as part of any merge, acquisition, sale of company assets, or transition
             of service to another provider, as well as in the unlikely event of any insolvency, 
             bankruptcy, or receivership in which the information pursuant to this Policy would be
              transferred to another entity as a result of such a proceeding, you acknowledge and 
              accept that the information pursuant to this Policy may form part of the transferred
               assets. You further acknowledge and accept that the acquirer or successor to SwyChr
                may continue to use the information pursuant to this Policy, in the manner set 
                forth in this Policy.
          
          

            



     </p>
    </div>
    </section>

    <FooterView />
</div>
 </template>
  
  <script  setup>
import CountryView from '@/components/CountryView.vue';
import FooterView from '@/components/FooterView.vue';  
 </script>

 <style>
  .question{
     font-family: 'Montserrat', sans-serif;
  text-align: justify;
   color: black;
   font-size: 70px;
   font-weight: 700;
   padding-bottom: 100px;
   margin-top: 30px;
   margin-left: 0;
}  

.term{ 
  text-align: center;
  margin: 0 auto;
  padding: 0.625rem 0;
  height: auto;
  position: relative; 
  width: 100%;
  align-items: center;
  justify-content: center;
}

.termson{
  padding-top: 3rem; 
  display: block;
  align-items: center;
  justify-content: center;
  margin-top: 0; 
   width: 95vw;
}

.termp{
  text-align: justify;
  line-height: 1;
  margin-left: 6.61vw; 
  width: 93%;
}
 </style>